import PropTypes from 'prop-types';

import {Grid, GridItem, Skeleton} from '@salesforce/retail-react-app/app/components/shared/ui';

import {Component} from '@amblique/king-living/app/components/contentful/component';

/**
 * Callout Block - Split (CF-023)
 *
 * @typedef {import('@chakra-ui/styled-system').SystemStyleObject} SystemStyleObject
 * @typedef {"root" | "grid" | "mediaRegion" | "contentRegion" | "body" | "cta"} HeroBannerParts
 * @typedef {Partial<Record<HeroBannerParts, SystemStyleObject>>} HeroBannerStyles
 *
 * @param {Object} props - Component props
 * @param {Contentful.HeroBanner} props.component - HeroBanner component data
 * @param {boolean} [props.isComplete] - Whether component has all fields
 * @param {boolean} [props.isFetching] - Whether additional data is being fetched
 * @param {HeroBannerStyles} [props.styles] - Whether additional data is being fetched
 * @returns {React.ReactElement}
 */
export const CalloutBlockSplitCF023 = ({component, isComplete = true, isFetching = false, styles, ...props}) => {
  const {backgroundMedia, body, cta} = component;

  return (
    <Grid {...styles.grid}>
      <GridItem className="hero-content-wrapper" {...styles.contentRegion}>
        {!isComplete && isFetching ? (
          <Skeleton height="80px" />
        ) : (
          <>
            {body && <Component component={body} {...styles.body} />}
            {cta && <Component component={cta} {...styles.cta} />}
          </>
        )}
      </GridItem>

      <GridItem className="hero-image-wrapper" {...styles.mediaRegion}>
        {backgroundMedia ? (
          <Component component={backgroundMedia} {...styles.media} />
        ) : (
          <Skeleton height="80px" />
        )}
      </GridItem>
    </Grid>
  );
};

CalloutBlockSplitCF023.displayName = 'CalloutBlockSplitCF023';
CalloutBlockSplitCF023.propTypes = {
  component: PropTypes.object.isRequired,
  isComplete: PropTypes.bool,
  isFetching: PropTypes.bool,
  styles: PropTypes.object.isRequired,
};
